import { useEffect } from 'react';

/**
 * Injects <link rel="alternate" hreflang="..."> tags directly into
 * document.head. react-helmet-async silently dedupes / drops multi-value
 * link rel="alternate" tags with different hreflang attributes, so we
 * bypass it the same way useJsonLd does for JSON-LD.
 *
 * @param {Array<{hreflang: string, href: string}>} alternates
 * @param {string} pageId  Unique identifier for cleanup
 */
const useHreflangAlternates = (alternates, pageId) => {
  useEffect(() => {
    const valid = Array.isArray(alternates)
      ? alternates.filter((a) => a && a.hreflang && a.href)
      : [];
    const ids = valid.map((a, i) => {
      const id = `hreflang-${pageId}-${i}`;
      let el = document.getElementById(id);
      if (!el) {
        el = document.createElement('link');
        el.rel = 'alternate';
        el.id = id;
        document.head.appendChild(el);
      }
      el.hreflang = a.hreflang;
      el.href = a.href;
      return id;
    });
    return () => {
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, [alternates, pageId]);
};

export default useHreflangAlternates;
